exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".card[data-v-ec830dda]{width:31.5rem;margin:1.25rem auto}@media (max-width:678px){.card[data-v-ec830dda]{width:100%}}.card .component-container[data-v-ec830dda]{border:none!important;padding:0}.total-import[data-v-ec830dda]{margin-top:.6rem}.total-price[data-v-ec830dda]{color:#00adbc}", ""]);

// exports
